var isObject = require('./_is-object');
var document = require('./_global').document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};



//////////////////
// WEBPACK FOOTER
// /home/runner/work/onelocal/onelocal/src/my-referral/~/.pnpm/core-js@2.6.12/~/core-js/modules/_dom-create.js
// module id = ../../../../../../core-js@2.6.12/node_modules/core-js/modules/_dom-create.js
// module chunks = 0